import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderNoHttpModule } from '../../global/loader-no-http/loader-no-http.module';
import { ResultBillingTableComponent } from './result-billing-table.component';

@NgModule({
  declarations: [ResultBillingTableComponent],
  exports: [ResultBillingTableComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatTableModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    LoaderNoHttpModule,
    MatOptionModule,
    MatSelectModule,
    ReactiveFormsModule,
  ],
})
export class ResultBillingTableModule {}
